export default tokenObject => ({
  token: tokenObject.token,
  tokenExpiration: tokenObject.token_expiration * 1000,
  expirationTime: Date.now() + tokenObject.token_expiration * 1000
});
